<template>
  <div id="cumulativevalue">
    <div class="title">累计值统计</div>
    <div class="cum_conent">
      <div class="conent_1">
        <p class="conent_color">累计节水</p>
        <p style="color:#649cff">{{watercount}}</p>
      </div>
      <div class="conent_2">
        <p class="conent_color">累计流量</p>
        <p style="color:#649cff">{{flowcount}}</p>  
      </div>
    </div>
  </div>
</template>

<script>
//import axios from 'axios'
export default {
  data(){
    return{
      watercount:'',
      flowcount:''
    }
  },
  mounted() {
    this.getdata();
    setInterval(() => {
      this.getdata()
    }, 300000);
  },
  methods:{
    getdata(){
//    var params = new URLSearchParams();
//    params.append("deptId", "892");
//    params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//    axios.post("/api/data/getCumulativeFlow", params)
//      .then((res) => {
//           console.log(res.data.data.resData)
          this.flowcount = "42104";
//      })
//      .catch((error) => {
//        console.log(error);
//      });

//    axios.post("/api/data/getCumulativeJs", params)
//      .then((res) => {
          // console.log(res.data.data.resData)
          this.watercount = "46625.4";
//      })
//      .catch((error) => {
//        console.log(error);
//      });
    }
  }
}
</script>

<style scoped>
#cumulativevalue{
    width: 100%;
    margin-top: 1.85vh;
    height: 17.96vh;
    background: url("@/assets/pengshui_bg.png") no-repeat center center;
    color: #ffffff;
    background-size: 100% 100%;
}
.title{
  height: 4.53vh;
  /* border: 1px solid red; */
  font-size: 18px;
  line-height: 4.53vh;
  text-align: start;
  margin-left: 1.04vw;
}
.cum_conent{
  background: url("@/assets/pengshui_19.png") no-repeat center center;
  background-size: 100% 100%;
  height: 11.2vh;
  width: 100%;
  margin-top: 1.94vh;
}
.conent_1{
  display: flex;
  justify-content: space-between;
  position: relative;
  right: -20%;
  width: 45%;
  border: 2px solid #b7c0d2;
  top: 0.92vh;
  height: 2.22vh;
  line-height: 2.22vh;
}
.conent_2{
  display: flex;
  justify-content: space-between;
  position: relative;
  right: -20%;
  width: 45%;
  border: 2px solid #b7c0d2;
  top: 1.85vh;
  height: 2.22vh;
  line-height: 2.22vh;
}
.conent_color{
  color: #b7c0d2;
  text-align: start;
  flex: 1;
}
</style>